import React from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';
import {Box} from '@material-ui/core';

import loader from './loader';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: loader()
};

const Loader = ({width, height}) => (
  <Box display="flex" justifyContent="center" my={2} data-testid="loader">
    <Lottie options={defaultOptions} width={width} height={height} />
  </Box>
);

Loader.defaultProps = {
  width: 80,
  height: 80
};

Loader.propTypes = {
  wrapperClasses: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired
};

export default Loader;
